module.exports = __webpack_public_path__ + "files/2fa0fc6e0796b2bc8023ef23414ffd5b.svg";